var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 5.5H5C4.44772 5.5 4 5.94772 4 6.5V17.5C4 18.0523 4.44772 18.5 5 18.5H19C19.5523 18.5 20 18.0523 20 17.5V6.5C20 5.94772 19.5523 5.5 19 5.5ZM5 3.5C3.34315 3.5 2 4.84315 2 6.5V17.5C2 19.1569 3.34315 20.5 5 20.5H19C20.6569 20.5 22 19.1569 22 17.5V6.5C22 4.84315 20.6569 3.5 19 3.5H5Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 16.25C11.5 15.8358 11.9477 15.5 12.5 15.5H17C17.5523 15.5 18 15.8358 18 16.25C18 16.6642 17.5523 17 17 17H12.5C11.9477 17 11.5 16.6642 11.5 16.25Z",
    fill: "#6F767E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28901 16.8047C6.02866 16.5444 6.02866 16.1223 6.28901 15.8619L10.1509 12L6.28901 8.13807C6.02866 7.87772 6.02866 7.45561 6.28901 7.19526C6.54936 6.93491 6.97147 6.93491 7.23182 7.19526L11.0937 11.0572C11.6144 11.5779 11.6144 12.4221 11.0937 12.9428L7.23182 16.8047C6.97147 17.0651 6.54936 17.0651 6.28901 16.8047Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.e85fb1aebad911b7c9bd8c8c5a1bc9c8.svg";
export { ForwardRef as ReactComponent };